import { styled } from '@mui/material';

import { Typography, Stack } from '@cast/design-system';
import type { StackProps } from '@cast/design-system';

const CertificateImage = styled('img')`
  vertical-align: middle;
`;

export const Certificates = (props: StackProps) => {
  return (
    <Stack direction="row" columnGap="8px" alignItems="center" {...props}>
      <CertificateImage
        src="/assets/img/certificates/SOC.png"
        width={28}
        height={28}
      />
      <CertificateImage
        src="/assets/img/certificates/ISO.png"
        width={28}
        height={28}
      />
      <Typography variant="P12M" style={{ verticalAlign: 'middle' }}>
        SOC2 & ISO27001 certified
      </Typography>
    </Stack>
  );
};
